module.exports = __webpack_public_path__ + "img/Logo2Tor_Color.52121ff5.jpg";